import Plan from './Plan';

export default Plan
export { Plan as Base }
